export enum ShipmentType {
    BOPIS = 'instore',
    SAME_DAY_DELIVERY = 'same-day-delivery',
}
